import React, { useEffect } from 'react';

const IUBENDA_SRC = "https://cdn.iubenda.com/iubenda.js";
let iubendaTimer = null;

/** Carica lo script di iubenda che elabora i link .iubenda-embed (usato anche da CookiePolicyLink).
 * I link montati insieme (privacy e cookie, doppio effetto di StrictMode) caricano un solo script; a ogni
 * nuovo montaggio lo script viene rieseguito, così elabora anche i link appena creati, ma nella pagina
 * ne resta sempre uno. Nella pagina generata da react-snap non viene aggiunto (lo aggiunge React all'avvio)
 */
export const loadIubenda = () => {
  if (navigator.userAgent === "ReactSnap") {
    return;
  }
  clearTimeout(iubendaTimer);
  iubendaTimer = setTimeout(() => {
    iubendaTimer = null;
    document.querySelectorAll('script[src="' + IUBENDA_SRC + '"]').forEach((s) => s.remove());
    const script = document.createElement('script');
    script.src = IUBENDA_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, 0);
};

//className: classi iubenda del link (di base il bottone nero; es. la landing lo vuole di solo testo)
const PrivacyPolicyLink = ({ className = "iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe" }) => {
  useEffect(() => {
    loadIubenda();
  }, []);

  return (
    <a
      href="https://www.iubenda.com/privacy-policy/15298448"
      className={className}
      title="Privacy Policy"
    >
      Privacy Policy
    </a>
  );
};

export default PrivacyPolicyLink;
